import { defineAsyncComponent } from 'vue'
export default {
  campaign: defineAsyncComponent(() => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/layouts/campaign.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/codebuild/output/src131634783/src/livebcn-headless/nuxtapp/layouts/default.vue").then(m => m.default || m))
}